import { cn } from "@/utils/cn";

const LoadingSpinnerV2 = ({ size = "70", className }) => {
  return (
    <div className={cn("flex justify-center items-center bg-white", className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 70 70"
        className="animate-spin"
        style={{ animationDuration: "1.5s" }} // Adjust the speed of the spin here
      >
        {/* Background Circle */}
        <path
          opacity="0.1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35 10C28.3696 10 22.0107 12.6339 17.3223 17.3223C12.6339 22.0107 10 28.3696 10 35C10 41.6304 12.6339 47.9893 17.3223 52.6777C22.0107 57.3661 28.3696 60 35 60C41.6304 60 47.9893 57.3661 52.6777 52.6777C57.3661 47.9893 60 41.6304 60 35C60 28.3696 57.3661 22.0107 52.6777 17.3223C47.9893 12.6339 41.6304 10 35 10ZM0 35C0 15.67 15.67 0 35 0C54.33 0 70 15.67 70 35C70 54.33 54.33 70 35 70C15.67 70 0 54.33 0 35Z"
          fill="black"
        />
        {/* Animated Black Spinner */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.0008 10C28.5555 9.98625 22.3565 12.4756 17.7108 16.9434C16.7484 17.8332 15.4751 18.3096 14.1649 18.2699C12.8548 18.2301 11.6126 17.6775 10.7058 16.731C9.79909 15.7845 9.30028 14.5198 9.3168 13.2091C9.33332 11.8985 9.86385 10.6467 10.7942 9.72337C17.301 3.47216 25.9778 -0.0131455 35.0008 3.72609e-05C36.3269 3.72609e-05 37.5987 0.526822 38.5364 1.4645C39.4741 2.40219 40.0008 3.67395 40.0008 5.00004C40.0008 6.32612 39.4741 7.59789 38.5364 8.53557C37.5987 9.47325 36.3269 10 35.0008 10Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

export default LoadingSpinnerV2;
